import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'rpe-page-template',
  templateUrl: './page-template.component.html',
  styleUrls: ['./page-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageTemplateComponent {

  @Input() title: string = ''
  @Input() route: string = ''

  constructor(private router: Router) {}

  goBack() {
    this.router.navigateByUrl(this.route)
  }
}
